import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from '../default-service';
import { DefaultFilter } from '../default-service.interface';
import { ErrorHandlerService } from '../error-handler.service';
import { InterceptorSkipHeader } from '../http-interceptor-skipheader.model';
import { Arquivo } from './model/arquivo.model';


export interface ArquivoFilter extends DefaultFilter {
  arquivo?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ArquivoService extends DefaultService<Arquivo> {

  static URL = '/api/arquivo/v1/arquivos';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandlerService,
      ArquivoService.URL
    );
  }

  getArquivo(nomeArquivo: string): Observable<any> {
    const httpOptions = {
      'responseType'  : 'blob' as 'json'
    };

    return this.httpClient
               .get<any>(`${ArquivoService.URL}/arquivo/${nomeArquivo}`, httpOptions)
               .pipe(
                  catchError ( err => throwError(this.errorHandlerService.handle(err)) )
               );
  } 

    arquivoMetadata(nomeArquivo: string): Observable<Arquivo> {
      const filter: ArquivoFilter = {
        arquivo: nomeArquivo
      };
      const params = DefaultService.converterFiltroParaHttpParam(filter);

      return this.httpClient
                 .get<Arquivo>(`${ArquivoService.URL}/arquivometadata`, {params})
                 .pipe(
                    catchError ( err => throwError(this.errorHandlerService.handle(err)) )
                 );
    } 
  
}
